import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {navigationPreferencesCtaStyle} from "../constants/navigation_shared_styles";

interface IProps {
    dataTestId: string;
    label: string;
    onNavigate: () => void;
}

export const PreferencesNavCta = (props: IProps) => {
    const {dataTestId, label, onNavigate} = props;

    return (
        <button className={cx(navigationPreferencesCtaStyle, buttonResetStyle)} data-testid={dataTestId} onClick={onNavigate} type="button">
            <Text color="var(--colors-white)" variant="button_small">
                {label}
            </Text>
        </button>
    );
};

const buttonResetStyle = css({
    border: 0,
    cursor: "pointer"
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {navigationPreferencesCtaStyle} from "../constants/navigation_shared_styles";

interface IProps {
    dataTestId: string;
    label: string;
    onNavigate: () => void;
}

export const PreferencesNavCta = (props: IProps) => {
    const {dataTestId, label, onNavigate} = props;

    return (
        <button className={cx(navigationPreferencesCtaStyle, buttonResetStyle)} data-testid={dataTestId} onClick={onNavigate} type="button">
            <Text color="var(--colors-white)" variant="button_small">
                {label}
            </Text>
        </button>
    );
};

const buttonResetStyle = css({
    border: 0,
    cursor: "pointer"
});
